var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"bg-gcode"},[_c('span',{staticClass:"bg-gcode-code"},[_vm._v(_vm._s(_vm.code))]),(_vm.description)?_c('span',{staticClass:"bg-gcode-desc"},[_vm._v(_vm._s(_vm.description))]):_vm._e(),(_vm.value !== null)?_c('span',{staticClass:"bg-gcode-value"},[_vm._v("−"+_vm._s(_vm._f("currency")(_vm.value)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }